import React from 'react'
import {Link} from 'react-router-dom'
import Obfuscate from 'react-obfuscate'

import footerLogo from '../assets/images/logo-footer.svg'

import {FlickImages} from './index'

const Footer = () => (
    <footer>
        <section className="footer-top">
            <div className="row">
                <div className="col-md-4">
                    <img src={footerLogo} alt="Grafični studio" className="logo" />
                    <p>Sodelujemo pri številnih projektih:</p>
                    <ul className="footer-links">
                        <li>
                            <a
                                href="https://www.gremojadrat.si/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fas fa-link" />Gremo jadrat
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.yachtcharteradria.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fas fa-link" />Yacht Charter Adria
                            </a>
                        </li>
                        <li>
                            <a
                                href="http://www.robertkuzma.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fas fa-link" />Robert Kuzma Blog
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="col-md-4">
                    <h4>Kontaktni podatki</h4>
                    <ul className="footer-contact-details">
                        <li>
                            <i className="fas fa-map-marker-alt" />
                            <span>Država:</span> Slovenia
                        </li>
                        <li>
                            <i className="fas fa-phone" />
                            <span>Telefon:</span> <Obfuscate tel="+386 41 721 046" />
                        </li>
                        <li>
                            <i className="fas fa-envelope" />
                            <span>Email:</span> <Obfuscate email="info@graficnistudio.net" />
                        </li>
                    </ul>
                </div>
                <div className="col-md-4">
                    <h4>Fotke</h4>
                    <FlickImages />
                </div>
            </div>
        </section>
        <section className="footer-bottom clearfix">
            <div className="copyright">
                © {new Date().getFullYear()} by <a href="/">Grafični studio™</a>. Vse pravice
                pridržane.
            </div>
            <nav className="links">
                <ul>
                    <li>
                        <Link to="/sitemap/">Zemljevid mesta</Link>
                    </li>
                    <li>
                        <Link to="/kontakt/">Kontakt</Link>
                    </li>
                </ul>
            </nav>
        </section>
    </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js